import React from 'react'
import { ImageTextItemInterface } from '@/types/newTypes'
import clsx from 'clsx'
import TryButtonBrand from './TryButtonBrand'
import { useTheme } from '@/components/ThemeProvider'

const OurTechnologiesBrand = ({ isWhitePage }: { isWhitePage?: boolean }) => {
  const { theme } = useTheme()
  const items: ImageTextItemInterface[] = [
    {
      img: '/img/our-technologies/1.svg',
      text: 'AI-Powered Photo Recognition',
    },
    {
      img: '/img/our-technologies/2.svg',
      text: 'Smart Algorithms for Optimal Space Saving',
    },
    {
      img: '/img/our-technologies/3.svg',
      text: 'Secure Photo Management',
    },
  ]
  return (
    <section className="flex flex-col gap-6 mb-8 relative">
      <h2 className="text-center px-4 text-XL font-bold">Our technologies</h2>
      <div className="flex flex-col gap-2  mx-auto w-full">
        {items.map((item, index) => (
          <figure
            key={index}
            className={clsx(
              'flex dark:gradient-card border border-transparent flex-row gap-4 items-center p-4 pt-[15px] pb-[9px] dark:pt-4 dark:pb-2.5 bg-white/15 rounded-3xl',
              {
                'gradient-card-light': theme === 'light',
              },
            )}
          >
            <img src={item.img} alt={item.text} className="max-w-10 min-w-10 h-[46px]" />
            <figcaption className="text-logo font-medium mb-1">{item.text}</figcaption>
          </figure>
        ))}
      </div>
      <div className=" mx-auto w-full">
        <TryButtonBrand to={isWhitePage ? '/new/email' : '/new/scan-results'} />
      </div>
    </section>
  )
}

export default OurTechnologiesBrand
